import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Form } from 'semantic-ui-react';

import { Column } from 'components/Layout';

import { DatePicker } from '../UI/DatePicker';
import { Input } from '../UI/Input';
import { SingleSelect } from '../UI/Select';
import { SuggestComuneNascita } from '../UI/GeoSuggest';

/* const SkinnyColumn = styled(Grid.Column) `
`;
const SkinnyRow = styled(Grid.Row) `
  padding: 0 !important;
`;
*/

export const BaseForm = ({ ...props }) => (
  <Form autoComplete="off" onSubmit={props.handleSubmit} loading={props.isSubmitting}>
    <Grid>
      <Column width={16}>
        <SingleSelect
          options={[
            {
              value: 'Carta identità',
              label: 'Carta identità',
            },
            {
              value: 'Passaporto',
              label: 'Passaporto',
            },
            {
              value: 'Patente',
              label: 'Patente',
            },
          ]}
          value={props.values.tipoDocumento}
          onChange={props.setFieldValue}
          onBlur={(name, isTouched) => {
            props.setFieldTouched(name, isTouched);
          }}
          error={props.errors.tipoDocumento}
          touched={props.touched.tipoDocumento}
          name="tipoDocumento"
          label="Tipo documento"
          required
        />
      </Column>
      <Column width={16}>
        <SingleSelect
          options={[
            {
              value: 'Comune',
              label: 'Comune',
            },
            {
              value: 'Consolato',
              label: 'Consolato',
            },
            {
              value: 'Ministero',
              label: 'Ministero',
            },
            {
              value: 'Motorizzazione civile',
              label: 'Motorizzazione civile',
            },
            {
              value: 'Questura',
              label: 'Questura',
            },
          ]}
          value={props.values.ente}
          onChange={props.setFieldValue}
          onBlur={(name, isTouched) => {
            props.setFieldTouched(name, isTouched);
          }}
          error={props.errors.ente}
          touched={props.touched.ente}
          name="ente"
          label="Ente"
          required
        />
      </Column>
      <Column width={16}>
        <Input label="Numero documento" {...props} name="numeroDocumento" required />
      </Column>
      <Column width={16}>
        <DatePicker
          {...props}
          value={props.values.dataEmissione}
          onChange={props.setFieldValue}
          name="dataEmissione"
          label="Data emissione"
          required
        />
      </Column>
      <Column width={16}>
        <DatePicker
          {...props}
          value={props.values.dataScadenza}
          onChange={props.setFieldValue}
          name="dataScadenza"
          label="Data scadenza"
          required
        />
      </Column>
      {/* <Column width={10}>
        <Input label="Comune" {...props} name="comune" required />
      </Column>
      <Column width={6}>
        <Input label="Provincia" {...props} name="provincia" required />
        </Column>*/}
      <Column width={16}>
        <SuggestComuneNascita
          initialValue={props.values.comuneNascita || props.values.comune || ''}
          onChange={props.setFieldValue}
          onBlur={(name, isTouched) => {
            props.setFieldTouched(name, isTouched);
          }}
          error={props.errors.comune}
          touched={props.touched.comune}
          name="comune"
          label="Comune"
          required
        />
      </Column>
    </Grid>
  </Form>
);

BaseForm.propTypes = {
  isSubmitting: PropTypes.bool,
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  onlyRead: PropTypes.bool,
};

export default BaseForm;



// WEBPACK FOOTER //
// ./app/components/Forms/DocumentoIdentita/baseForm.js